import { createRouter, createWebHistory } from 'vue-router'
import { routes } from '@/router/routes'
import PageNotFound from '@/pages/404.vue';
import { Auth } from '@/stores/auth';

const router = createRouter({
    history: createWebHistory(),
    routes: [
        ...routes,
        {
            path: "/:catchAll(.*)",
            name: "pageNotFound",
            component: PageNotFound,
            meta: {
                requiresAuth: false
            }
        }
    ]
})

router.beforeEach(async (to, from, next) => {
    const auth = Auth();
    const token = auth.getToken();

    if (to.matched.some((record) => record.meta.auth)) {
        if (!token) {
            next('/login');

            return;
        }

        try {
            // Make an API call to verify the token
            const isValidToken = await auth.verifyToken();

            if (!isValidToken) {
                next( '/login');

                return;
            }

            // Let the user access the route if no restrictions apply
            next();
        } catch (error) {
            next('/login'); // Redirect to login if verification fails
        }
    } else {
        if (auth.isAuthenticated && to.path == '/login') {
            next('/contacts');

            return;
        }

        next();
    }
});

export default router
